export default "__VITE_ASSET__DNys$qFM__"